import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilter } from '../../../../shared/models/filter';
import { ContractorService } from '../../services/contractor.service';
import { environment } from 'src/environments/environment';
interface IProjectNewModalContext {
  title?: string;
  addedData?: any;
}
@Component({
  selector: 'payment-review-new-modal',
  templateUrl: './payment-preview.component.html',
  styleUrls: ['./payment-preview.component.scss'],
})
export class PaymentReviewModalComponent implements OnInit, OnDestroy {
  procurementType: any = [];

  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pendingArr = [];
  bidderId: any = JSON.parse(localStorage.getItem('userData')).appUser
    .appUserId;
  data: any;
  createProcurementItem: FormGroup;
  procurementCycleParams: AppFilter;
  currentPage = 1;
  public maxSize = 5;
  eServicesURL = environment.ESERVICES_URL;
  token;
  total = 5;
  optionsvalues = [];
  cycleId;
  addedData;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IProjectNewModalContext, void, void>,
    private router: Router,
    private service: ContractorService,
    private activatedRoute: ActivatedRoute
  ) {
    this.addedData = modal.context.addedData;
    console.log(this.addedData);

    this.createProcurementItem = fb.group({
      description: ['', Validators.required],
      payerAddress: ['', Validators.required],
      payerName: ['', Validators.required],
      amount: ['', Validators.required],
      payerPhone: ['', Validators.required],
      payerEmail: ['', Validators.required],
    });

    this.token = JSON.parse(localStorage.getItem('userData'))
      ? JSON.parse(localStorage.getItem('userData'))['token']
      : null;

    this.addedData.additionalDetails = this.parseJSON(
      this.addedData.additionalDetails
    );

    let transactionParam = {
      description: this.addedData.additionalDetails.description,
      name: this.addedData.additionalDetails.payerName,
      phone: this.addedData.additionalDetails.payerPhone,
      email: this.addedData.additionalDetails.payerEmail,
      address: this.addedData.additionalDetails.payerAddress,
      paymentLink: this.addedData.paymentLink,
      transactionRef: this.addedData.transactionReference,
      purpose: 'Tender',
      amount: this.addedData.additionalDetails.amount,
      path: `${window.location.href.split('?')[0]}?message=success`,
    };

    let routeParams = encodeURIComponent(JSON.stringify(transactionParam));

    this.addedData.paymentLink = `${this.eServicesURL}/redirect?token=${this.token}&route=contractor/payment/instruction&routeBody=${routeParams}`;
  }

  isFieldValid(field: string) {
    return (
      (!this.createProcurementItem.get(field).valid &&
        this.createProcurementItem.get(field).touched) ||
      (this.createProcurementItem.get(field).untouched &&
        this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      pending: field,
    };
  }

  save() {}

  nullify() {
    this.success = null;
    this.error = null;
  }

  onSubmit() {}

  ngOnInit() {
    this.document.body.classList.add('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('panel');
  }

  parseJSON(value): any {
    if (typeof value === 'string') {
      return JSON.parse(value);
    } else {
      return value;
    }
  }
  tenderPayment() {
    // this.callStarted();
    // this.service
    //   .createTenderPayment({
    //     lotId: this.addedData.lotId,
    //     biddingStageId: this.addedData.biddingStageId,
    //     bidderId: this.addedData.bidderId,
    //     body: this.addedData,
    //   })
    //   .subscribe(
    //     (res) => {
    //       this.success = 'Tender Payment Successful';
    //       this.callCompleted();
    //       setTimeout(() => {
    //         this.modal.approve();
    //       }, 2000);
    //     },
    //     (error) => {
    //       this.error = error.error ? error.error : error;
    //       this.callCompleted();
    //     }
    //   );
  }
}

export class PaymentReviewModal extends ComponentModalConfig<
  IProjectNewModalContext,
  void,
  void
> {
  constructor(
    title: string,
    addedData: any,
    size: ModalSize = ModalSize.Small
  ) {
    super(PaymentReviewModalComponent, { title, addedData });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
